import React from "react";
import { NEED_STATUSES, URGENCY_LEVELS, CATEGORY_COLOR } from "./api";
import { CustomIcon } from "../shared/CustomIcon";
import { formatDate } from "../../lib/format";

const URGENCY_COLOR = { High: "#ff6b6b", Medium: "var(--kc-accent)", Low: "#60a5fa" };
const STATUS_COLOR  = { Open: "#60a5fa", "In Progress": "var(--kc-accent)", Fulfilled: "#4ade80" };

// Community Needs Registry — running list of current needs.
export default function CommunityNeedsTab({ needs, currentUser, onDelete, onNew, onEdit }) {
  const remove = async (n) => {
    if (!window.confirm("Remove this community need?")) return;
    await onDelete(n);
  };

  return (
    <div data-testid="needs-tab">
      <div className="don-toolbar">
        <div className="don-toolbar-filters">
          <span className="don-filter-label">Current community needs</span>
        </div>
        <button className="btn btn-gold" data-testid="need-new-btn" onClick={onNew}>+ New Need</button>
      </div>

      {needs.length === 0 ? (
        <div className="don-empty">No community needs recorded yet.</div>
      ) : (
        <div className="don-list" data-testid="needs-list">
          {needs.map(n => {
            const catColor = CATEGORY_COLOR[n.category] || "var(--kc-accent)";
            const urgencyColor = URGENCY_COLOR[n.urgency] || "var(--kc-accent)";
            const statusColor = STATUS_COLOR[n.status] || "var(--kc-accent)";
            return (
              <div key={n.id} className="don-row" data-testid={`need-row-${n.id}`} onClick={() => onEdit(n)}>
                <div className="don-row-icon" style={{ borderColor: urgencyColor, color: urgencyColor, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>{n.source === "food_form" ? <CustomIcon name="food" size={18} /> : "!"}</div>
                <div className="don-row-main">
                  <div className="don-row-title" style={{ textTransform: "none", fontFamily: "'Montserrat',sans-serif", fontSize: 14 }}>{n.description}</div>
                  <div className="don-row-meta">
                    <span>{formatDate(n.dateAdded)}</span>
                    {n.source === "food_form" && n.createdAt && (
                      <span style={{ color: "color-mix(in srgb, var(--kc-accent) 85%, transparent)" }}>· {new Date(n.createdAt).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}</span>
                    )}
                    {n.notes && <span>{n.notes.slice(0, 80)}{n.notes.length > 80 ? "…" : ""}</span>}
                  </div>
                </div>
                <div className="don-row-chips" onClick={e => e.stopPropagation()}>
                  {n.source === "food_form" && <span className="don-chip" data-testid={`need-source-${n.id}`} style={{ color: "var(--kc-accent)", background: "color-mix(in srgb, var(--kc-accent) 16%, transparent)", fontWeight: 700 }}>FOOD REGISTRATION</span>}
                  <span className="don-chip" style={{ color: catColor, background: `${catColor}1F` }}>{n.category}</span>
                  <span className="don-chip" style={{ color: urgencyColor, background: `${urgencyColor}1F` }}>{n.urgency}</span>
                  <span className="don-chip" style={{ color: statusColor, background: `${statusColor}1F` }}>{n.status}</span>
                  <button className="btn btn-sm btn-outline" data-testid={`need-edit-${n.id}`} onClick={() => onEdit(n)}>{n.source === "food_form" ? "View" : "Edit"}</button>
                  <button className="btn btn-sm btn-danger" data-testid={`need-delete-${n.id}`} onClick={() => remove(n)}>Delete</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
